var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 99C76.8381 99 99 76.8381 99 49.5C99 22.1619 76.8381 0 49.5 0C22.1619 0 0 22.1619 0 49.5C0 76.8381 22.1619 99 49.5 99Z",
    fill: "#E0EAE4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5283_28373",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 93,
    height: 92
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0469 91.9287C75.4323 91.9287 96.0112 71.3497 96.0112 45.9643C96.0112 20.5789 75.4323 0 50.0469 0C24.6615 0 4.08252 20.5789 4.08252 45.9643C4.08252 71.3497 24.6615 91.9287 50.0469 91.9287Z",
    fill: "#EDF5F1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5283_28373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0045 44.0492C58.9374 44.0492 65.3683 37.6183 65.3683 29.6854C65.3683 21.7525 58.9374 15.3215 51.0045 15.3215C43.0715 15.3215 36.6406 21.7525 36.6406 29.6854C36.6406 37.6183 43.0715 44.0492 51.0045 44.0492Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0468 111.08C68.0282 111.08 82.6049 96.5038 82.6049 78.5224C82.6049 60.5411 68.0282 45.9644 50.0468 45.9644C32.0655 45.9644 17.4888 60.5411 17.4888 78.5224C17.4888 96.5038 32.0655 111.08 50.0468 111.08Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogin);
export default __webpack_public_path__ + "static/media/icon_login.e1b1abcd37174dc0fa0d56c658db8a55.svg";
export { ForwardRef as ReactComponent };